import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createMetaManager } from 'vue-meta'
import prismic from "./prismic/prismic";
import {
  PrismicRichText,
  PrismicText,
  PrismicLink,
  PrismicImage,
  SliceZone,
} from "@prismicio/vue";

createApp(App)
  .use(store)
  .use(router)
  .use(prismic)
  .component("PrismicRichText", PrismicRichText)
  .component("PrismicText", PrismicText)
  .component("PrismicLink", PrismicLink)
  .component("PrismicImage", PrismicImage)
  .component("SliceZone", SliceZone)
  // .use(i18n)
  // .use(VueGtag, {
  //   bootstrap: false,
  //   params: {
  //     anonymize_ip: true
  //   }    
  // })
  .use(createMetaManager())
  .mount('#app');
